(function ($) {
    document.addEventListener('accordion:ready', function () {
        var hash = window.location.hash.replace("#", "").replace(/[^a-zA-Z0-9-_]/g, '');
        if (!hash || !$('#' + hash).length) return;
        var $target = $('#' + hash);
        var topAccordion = $target.offset().top - 100;
        $('html, body').animate({ scrollTop: topAccordion });
        $target.find('.card-header > button').click();
    });
})(jQuery, Drupal);
